module.exports = __webpack_public_path__ + "img/104078.5d238835.png";